import { axiosInstance } from '../axios-instance';
import { IPageResponse } from '@/types/common.types';
import { IAnnouncementListParams, IAnnouncement } from './types';

export const getAnnouncements = async (
  params: IAnnouncementListParams
): Promise<IPageResponse<IAnnouncement>> => {
  return axiosInstance.get('/my-announcements', { params });
};

export const markAnnouncementAsRead = async (id: string) => {
  return axiosInstance.patch(`/my-announcements/${id}`, { status: true });
};
